// extracted by mini-css-extract-plugin
module.exports = {"mainTable":"Static_mainTable__1X66G"};